import { ActivatableTransportType } from './../model/activatable-transport-type.enum';
import { ResponseStatus } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { ActivatableTransport } from '../model/activatable-transport';
import { HttpService } from '@sdbn/appclient';
import { ResponseMessage } from '@sdbn/appclient';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { ActivatableTransportQuery } from '../model/activatable-transport-query';
import { ActivateTransportDetails } from '../model/activate-transport-details';
import { ConfigurationService } from '@sdbn/appclient';
import { map } from 'rxjs/operators';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from 'src/environments/environment';


export class ActivateTransportDialogData {
  query: string;
}

@Component({
  selector: 'app-activate-transports-dialog',
  templateUrl: './activate-transports-dialog.component.html',
  styleUrls: ['./activate-transports-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivateTransportsDialogComponent implements OnInit {

  selectedType = ActivatableTransportType.NOT_RELEVANT;

  queryType = ActivatableTransportType;

  responseMessages: ResponseMessage[];

  isLoading = false;

  defaultVisibleColumns = [
    'selection', 'planningDate', 'carrier', 'identifier', 'string2', 'registrationCode', 'options', 'cargo'
  ];

  columnsToDisplay = this.defaultVisibleColumns;
  dataSource = new MatTableDataSource(new Array<ActivatableTransport>());
  selection = new SelectionModel<ActivatableTransport>(true);

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<ActivateTransportsDialogComponent>,
    private configurationService: ConfigurationService,
    private httpService: HttpService,
    @Inject(MAT_DIALOG_DATA) public data: ActivateTransportDialogData) {
    this.initVisibleColumns();
  }

  ngOnInit() {
    this.loadTransports();

    console.log('data is', this.data);
  }

  private initVisibleColumns() {
    this.columnsToDisplay = [];

    const visibleColumns = this.configurationService.getClientParamValue('ui-component.activate-transports-dialog.transport.columns', null);

    if (visibleColumns != null && String(visibleColumns).length > 0) {

      this.columnsToDisplay.push('selection');

      const columProperties = String(visibleColumns).split('|');
      for (const p of columProperties) {
        const checkColumn = this.defaultVisibleColumns.indexOf(p) !== -1;
        if (checkColumn) {
          this.columnsToDisplay.push(p);
        }
      }
    } else {
      this.columnsToDisplay.push(...this.defaultVisibleColumns);
    }
    console.log(this.columnsToDisplay);
  }

  private loadTransports() {
    this.isLoading = true;

    const query = new ActivatableTransportQuery();
    query.query = this.data.query;
    query.type = this.selectedType;

    this.httpService.postWithContext<ActivatableTransport[]>(environment.transportActivationEndpoint, query).pipe(map(
      t => t.map(tr => new ActivatableTransport(tr))
    )).subscribe(
      transports => {
        this.dataSource.data = transports;
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        console.error('Error retrieving data ' + error);
      }
    );
  }

  public performSearch() {
    this.responseMessages = [];
    this.selection.clear();
    this.loadTransports();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  public isActivateTransportsEnabled() {
    if (this.isLoading) {
      return false;
    }

    return this.selection.hasValue(); // selected.length > 0;
  }

  public activateTransports() {
    this.isLoading = true;
    this.responseMessages = [];

    const selectedIds = new Array<number>();
    for (const selected of this.selection.selected) {
      selectedIds.push(selected.id);
    }

    const details = new ActivateTransportDetails();
    details.transportIds = selectedIds;
    details.type = this.selectedType;

    this.httpService.postWithContext<ServiceResponse>(environment.transportActivationEndpoint + '/activate', details).subscribe(
      response => {
        this.isLoading = false;
        if (response != null) {
          if (response.status !== ResponseStatus.SUCCESS) {
            this.responseMessages = response.responseMessages;
          } else {
            this.dialogRef.close();
          }
        }
      }, error => {
        this.isLoading = false;
        console.log('Error while activating transports ' + error);
      }
    );
  }

  public selectedTypeChanged($event) {
    this.selection.clear();
    this.dataSource.data = new Array<ActivatableTransport>();
  }

  public toggleSelection(transport: ActivatableTransport) {
    if (transport.selected) {
      transport.selected = false;
      this.selection.deselect(transport);
    } else {
      transport.selected = true;
      this.selection.select(transport);
    }
    console.log(this.selection);
  }

  /**
 * Controls "no data" message in table if no rows are available
 */
  public showNoData(): boolean {
    return this.dataSource.filteredData.length === 0;
  }
}
